import { CalendarClock, ShieldCheck, Axe } from "lucide-react";
import { Eyebrow, Reveal } from "./shared";

const PILLARS = [
  {
    num: "01",
    icon: CalendarClock,
    title: "The Friday Batch",
    body: "Why only Fridays? Batching every job into one route day means zero dead drive time — and that density is exactly how a one-man operation beats every two-crew quote you've gotten.",
  },
  {
    num: "02",
    icon: ShieldCheck,
    title: "Totally Contactless",
    body: "No knocking, no clipboard, no taking a half-day off work to 'walk the property.' You text a photo, I text a firm price, Friday it's gone. The whole transaction fits in your messages app.",
  },
  {
    num: "03",
    icon: Axe,
    title: "One Job Done Right",
    body: "I don't trim trees, mow grass, or build decks. Stump grinding is the entire business — which means the machine is sharp, the process is dialed, and your yard is the only thing on the schedule.",
  },
];

export default function Manifesto() {
  return (
    <section id="model" data-testid="manifesto-section" className="mx-auto max-w-7xl scroll-mt-20 px-4 py-20 sm:px-8 sm:py-28">
      <Reveal>
        <Eyebrow>01 — The Friday Model</Eyebrow>
        <h2 className="mt-4 max-w-2xl font-display text-2xl font-black uppercase leading-tight tracking-tight text-bone sm:text-3xl lg:text-4xl">
          The easiest service <span className="text-amber-500">you'll ever hire.</span>
        </h2>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-3">
        {PILLARS.map((p, i) => (
          <Reveal key={p.num} delay={i * 0.12} className={i === 1 ? "md:translate-y-8" : ""}>
            <article
              data-testid={`manifesto-card-${p.num}`}
              className="group flex h-full flex-col border border-stone-800 bg-charcoal p-8 transition-colors duration-200 hover:border-amber-500/60"
            >
              <div className="flex items-start justify-between">
                <span className="font-display text-5xl font-black leading-none text-stone-800 transition-colors duration-200 group-hover:text-amber-500/30">
                  {p.num}
                </span>
                <p.icon className="h-6 w-6 text-amber-500" strokeWidth={1.5} />
              </div>
              <h3 className="mt-8 font-display text-xl font-bold uppercase tracking-normal text-bone sm:text-2xl">
                {p.title}
              </h3>
              <p className="mt-4 text-sm leading-relaxed text-stone-400 sm:text-base">
                {p.body}
              </p>
            </article>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
